import React from "react";

const BalanceIcon = ({ isActive }: { isActive: boolean }) => {
  return (
    <svg
      width="42"
      height="43"
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="21"
        cy="21.5"
        r="21"
        fill={isActive ? "#4E5257" : "#ebe8e8"}
      />
      <path
        d="M29.3338 20.641V22.3577C29.3338 22.816 28.9672 23.191 28.5005 23.2077H26.8672C25.9672 23.2077 25.1422 22.5493 25.0672 21.6493C25.0172 21.1243 25.2172 20.6327 25.5672 20.291C25.8755 19.9743 26.3005 19.791 26.7672 19.791H28.5005C28.9672 19.8077 29.3338 20.1827 29.3338 20.641Z"
        fill={isActive ? "#C8EE44" : "black"}
      />
      <path
        d="M28.0587 24.4584H26.867C25.2837 24.4584 23.9503 23.2667 23.817 21.7501C23.742 20.8834 24.0587 20.0167 24.692 19.4001C25.2253 18.8501 25.967 18.5417 26.767 18.5417H28.0587C28.3003 18.5417 28.5003 18.3417 28.4753 18.1001C28.292 16.0751 26.9503 14.6917 24.9587 14.4584C24.7587 14.4251 24.5503 14.4167 24.3337 14.4167H16.8337C16.6003 14.4167 16.3753 14.4334 16.1587 14.4667C14.0337 14.7334 12.667 16.3167 12.667 18.5834V24.4167C12.667 26.7167 14.5337 28.5834 16.8337 28.5834H24.3337C26.667 28.5834 28.2753 27.1251 28.4753 24.9001C28.5003 24.6584 28.3003 24.4584 28.0587 24.4584ZM21.8337 19.6251H16.8337C16.492 19.6251 16.2087 19.3417 16.2087 19.0001C16.2087 18.6584 16.492 18.3751 16.8337 18.3751H21.8337C22.1753 18.3751 22.4587 18.6584 22.4587 19.0001C22.4587 19.3417 22.1753 19.6251 21.8337 19.6251Z"
        fill={isActive ? "#C8EE44" : "black"}
      />
    </svg>
  );
};

export default BalanceIcon;
